import React, { useState } from "react";
import footer1 from "../../images/footer1.png";
import footer2 from "../../images/footer2.png";
import footerM1 from "../../images/footerm1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXTwitter,
  faInstagram,
  faGithub
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  const [subscribed, setSubscribed] = useState("");
  const [email, setEmail] = useState("");

  const handleSubscribe = () => {
    if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setSubscribed("subscribed");
      setEmail("");
    } else {
      setSubscribed("notValid");
    }
  };
  return (
    <div className="bg-white mt-6">
      {/* Footer Image Big screen */}
      <div className="flex-col items-center md:py-2 hidden md:block">
        <img src={footer1} alt="Footer" className="w-full " />
      </div>

      {/* Footer Image for Mobile Screen */}
      <div className="flex flex-col items-center py-2 md:hidden border-t mb-3">
        <img src={footerM1} alt="Footer" className="w-full " />
      </div>

      {/* Subscription Part */}
      <div className="flex md:flex-row flex-col space-y-2 justify-between md:items-center py-6 px-2 md:px-16 bg-red-50 font-sans">
        <div>
          <p className="md:text-2xl text-lg font-semibold">
            Get Coupons & Offers
          </p>
          <p className="text-gray-400 ">You may unsubscribe at any moment.</p>
        </div>

        <div className="flex">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="p-2 border-y-2 border-l-2 border-gray-400 focus:outline-none md:w-80 w-full"
          />
          <button
            className="bg-red-600 text-white md:text-md text-sm font-semibold md:w-32 p-2"
            onClick={handleSubscribe}
          >
            {subscribed === "subscribed" ? "SUBSCRIBE" : "SUBSCRIBED"}
          </button>
        </div>
        {subscribed === "subscribed" && (
          <div className="text-center text-green-600 font-sans py-2">
            Congrats! Now you are member of STITCHD.
          </div>
        )}
        {subscribed === "notValid" && (
          <div className=" text-red-600 font-sans">
            Please enter a valid email address.
          </div>
        )}
      </div>

      {/* Footer Content */}
      <div className="flex md:flex-row flex-col justify-between items-center border-y border-gray-400 md:px-16 p-2">
        <div>
          <img src={footer2} alt="Footer Logo" className="w-full h-16" />
        </div>
        <div className="flex space-x-4">
          <a
            href="https://github.com/Rohit5464"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-800 hover:text-gray-400"
          >
            <FontAwesomeIcon icon={faGithub} size="2x" />
          </a>
          <a
            href="https://x.com/rohitdubey_5464"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-800 hover:text-blue-600"
          >
            <FontAwesomeIcon icon={faXTwitter} size="2x" />
          </a>
          <a
            href="https://www.instagram.com/rohit_dubey_._/?r=nametag"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-800 hover:text-pink-600"
          >
            <FontAwesomeIcon icon={faInstagram} size="2x" />
          </a>
          <a
            href="mailto:rohit.work5464@gmail.com"
            className="text-gray-800 hover:text-red-600"
          >
            <FontAwesomeIcon icon={faEnvelope} size="2x" />
          </a>
        </div>
      </div>

      {/* Footer Links */}
      <div className="flex flex-col md:flex-row justify-between items-center border-t border-gray-400 md:px-16 p-2 bg-gray-100">
        <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-8 text-gray-800">
          <a href="https://ro-hit-portfolio.vercel.app/"  target="_blank" className="hover:text-red-600">
            About Us
          </a>
          <a href="https://ro-hit-portfolio.vercel.app/"  target="_blank" className="hover:text-red-600">
            Contact Us
          </a>
          <a href="/" className="hover:text-red-600">
            Privacy Policy
          </a>
          <a href="/" className="hover:text-red-600">
            Terms & Conditions
          </a>
          <a href="/" className="hover:text-red-600">
            Cancellation/Refund Policies
          </a>
        </div>
        <div className="text-gray-400 font-sans py-1">
          © 2024 RO-HIT. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Footer;
